import { render, staticRenderFns } from "./project-partner-work-orders.vue?vue&type=template&id=56e8851c&scoped=true"
import script from "./project-partner-work-orders.vue?vue&type=script&lang=js"
export * from "./project-partner-work-orders.vue?vue&type=script&lang=js"
import style0 from "./project-partner-work-orders.vue?vue&type=style&index=0&id=56e8851c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e8851c",
  null
  
)

export default component.exports